import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Chip,
  Box,
  TablePagination,
  Tooltip,
  TableSortLabel,
} from '@mui/material';
import { Edit, Delete, AccountTree, People } from '@mui/icons-material';
import useSortTable from '../../../hooks/useSortTable';

const AreaTable = ({ areas, onEdit, onDelete, page, onPageChange, pagination }) => {
  const { sorted, sortBy, sortDir, handleSort } = useSortTable(areas);

  if (!areas || areas.length === 0) {
    return (
      <Paper sx={{ p: 3, textAlign: 'center' }}>
        <AccountTree sx={{ fontSize: 60, color: 'text.secondary', mb: 2 }} />
        <p>No hay áreas registradas</p>
      </Paper>
    );
  }

  const handleChangePage = (event, newPage) => {
    onPageChange(newPage + 1);
  };

  const SortCell = ({ label, field, align, sx: extraSx }) => (
    <TableCell align={align} onClick={() => handleSort(field)} sx={{ cursor: 'pointer', userSelect: 'none', ...extraSx }}>
      <TableSortLabel active={sortBy === field} direction={sortBy === field ? sortDir : 'asc'}>
        {label}
      </TableSortLabel>
    </TableCell>
  );

  return (
    <Paper>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <SortCell label="Nombre" field="name" />
              <SortCell label="Código" field="code" sx={{ display: { xs: 'none', sm: 'table-cell' } }} />
              <SortCell label="Empresa" field="company.name" sx={{ display: { xs: 'none', md: 'table-cell' } }} />
              <SortCell label="Usuarios Asignados" field="_count.areaUsers" align="center" sx={{ display: { xs: 'none', sm: 'table-cell' } }} />
              <TableCell align="right">Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sorted.map((area) => (
              <TableRow key={area.id} hover>
                <TableCell>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <AccountTree color="primary" />
                    <strong>{area.name}</strong>
                  </Box>
                </TableCell>
                <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
                  <Chip label={area.code} size="small" color="primary" variant="outlined" />
                </TableCell>
                <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>
                  {area.company ? (
                    <Box>
                      <div>{area.company.name}</div>
                      <small style={{ color: 'gray' }}>{area.company.short}</small>
                    </Box>
                  ) : (
                    '-'
                  )}
                </TableCell>
                <TableCell align="center" sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
                  <Tooltip title="Usuarios asignados">
                    <Chip
                      icon={<People />}
                      label={area._count?.areaUsers || 0}
                      size="small"
                      color="secondary"
                    />
                  </Tooltip>
                </TableCell>
                <TableCell align="right">
                  <Tooltip title="Editar">
                    <IconButton size="small" color="primary" onClick={() => onEdit(area)}>
                      <Edit />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Eliminar">
                    <IconButton size="small" color="error" onClick={() => onDelete(area.id)}>
                      <Delete />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {pagination && (
        <TablePagination
          component="div"
          count={pagination.total || 0}
          page={(page || 1) - 1}
          onPageChange={handleChangePage}
          rowsPerPage={pagination.limit || 10}
          rowsPerPageOptions={[10]}
          labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`
          }
        />
      )}
    </Paper>
  );
};

export default AreaTable;
